import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { ContentSection } from '../../../components/ContentSection';
import { Subtitle } from '../../../components/Subtitle';
import { BackToTopButton } from '../../../components/_shell/BackToTopButton';
import { PageContent, VideoContainer } from './styles';
import { NotFound } from '../../NotFound';
import { Skeleton } from 'antd';
import { Video } from '../../../components/Video';
import { VideoTag } from './interfaces/Video';
import { RelatedVideos } from './components/RelatedVideos';
import useGetByIdRequest from './hooks/search/useGetByIdRequest';
import slug from '../_shared/slug';
import { useAuthCtx } from '../../../features/auth_v2/hooks/useAuthCtx';
import { ErrorMessage } from '../../../components/ErrorMessage';
import { dateShort } from '../../../util/i18n';

interface RouteParams {
  videoId: string;
}

export const VideoView = (props: RouteComponentProps<RouteParams>) => {
  const { videoId } = props.match.params;
  const { session } = useAuthCtx();
  const history = props.history;
  const { loading, error, data, getVideo } = useGetByIdRequest();
  const getVideoById = async (id: string) => getVideo(id);

  let unauthorized = false;
  const client = session.client;
  if (client && client.all_content_view) {
    const contractedTags = session.client.contracted_tags || [];
    const videoSerie = contractedTags.find((tag: any) =>
      data && data.video_serie && tag.id
        ? tag.id === data.video_serie.id
        : false
    );
    if (!videoSerie) {
      unauthorized = true;
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getVideoById(videoId);
  }, [videoId]);

  useEffect(() => {
    if (!data) return;
    history.replace(
      `/conteudo/videos/${videoId}${data.title ? `/${slug(data.title)}` : ''}`
    );
  }, [data]);

  if (unauthorized) return <ErrorMessage unauthorized={true} />;
  if (error) return <NotFound />;

  const getOnlyTag = (type: string, tags: any) =>
    tags
      .filter((e: VideoTag) => e.prefix === type)
      .map((e: VideoTag) => e.title)
      .join(', ');

  const validTags = (tags: any) => typeof tags === 'object' && tags.length;
  const author = (tags: any) => validTags(tags) && getOnlyTag('author', tags);
  const keywords = (tags: any) => validTags(tags) && getOnlyTag('kwrd', tags);
  const event = (tags: any) => validTags(tags) && getOnlyTag('event', tags);
  const serie = (el: any) => el && el.video_serie && el.video_serie.title;

  return (
    <PageContent>
      <Skeleton loading={loading}>
        <VideoContainer>
          <Video videoSrc={data.url} />
        </VideoContainer>

        <ContentSection className="video-details-container">
          <div className="container">
            <Subtitle>{data.title}</Subtitle>
            <div>
              <b>Palestrante(s):</b> {author(data.tags)}
            </div>
            <div>
              <b>Data:</b> {dateShort(data.event_date)}
            </div>
            <div>
              <b>Série:</b> {serie(data)}
            </div>
            <div>
              <b>Palavras-chave:</b> {keywords(data.tags)}
            </div>
            <div>
              {event(data) === '' ? (
                <>
                  <b>Evento:</b> {event(data)}
                </>
              ) : null}
            </div>
            <br />
            <p>{data.description}</p>
          </div>
        </ContentSection>
        <RelatedVideos id={videoId} />
      </Skeleton>
      <BackToTopButton />
    </PageContent>
  );
};
